import {i18n} from '@/plugins/i18n'

export const wageType = {
    PERCENT: 'PERCENT',
    FIXED: 'FIXED',
    PERIODIC: 'PERIODIC',
};

export const wageTypeStr = {
    PERCENT: i18n.t('customers_club.setting.percent'),
    FIXED: i18n.t('customers_club.setting.constant'),
    PERIODIC: i18n.t('customers_club.setting.periodic'),

    get(type) {
        let type_str = null;

        Object.keys(wageType).forEach(item => {
            if (wageType[item] === type) {
                type_str = wageTypeStr[item];
            }
        });

        return type_str;
    }
};
